import ReactDOM from "react-dom/client";
import "./index.css";
import { BrowserRouter } from "react-router-dom";
import { ChakraProvider } from "@chakra-ui/react";
import App from "./App";
import { Provider } from "react-redux";
import { store } from "./store";
import ErrorBoundary from "./components/ErrorBoundary/ErrorBoundary";
import { NavbarProvider } from "./context/NavbarContext";

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(
  <ChakraProvider>
    <Provider store={store}>
      <BrowserRouter
        future={{
          v7_startTransition: true,
          v7_relativeSplatPath: true,
        }}
      >
        <NavbarProvider>
          <ErrorBoundary>
            <App />
          </ErrorBoundary>
        </NavbarProvider>
      </BrowserRouter>
    </Provider>
  </ChakraProvider>,
);
